var exports = {
  "kL": "xfb577c5e--6b12d7--container",
  "Pf": "xfb577c5e--6b12d7--label",
  "Uq": "xfb577c5e--6b12d7--value",
};

module.exports = exports;
